/*
  Contact form. Submits natively so Shopify's hCaptcha can verify it, then Shopify redirects back with
  ?contact_posted=true and the page renders the success state. The first name and reply method are kept
  in sessionStorage so the success message can use them after the reload.
*/
if (!customElements.get('sok-contact-form')) {
  const STORE_KEY = 'sok-contact-sent';

  class SokContactForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.fields = this.querySelector('[data-fields]');
      this.success = this.querySelector('[data-success]');
      this.submitButton = this.querySelector('[data-submit]');
      this.phone = this.querySelector('[data-phone]');

      // Phone and text replies need a number to reach.
      this.form.addEventListener('change', (event) => {
        if (event.target.name === 'contact[Preferred contact]') this.syncPhone();
      });
      this.syncPhone();

      this.form.addEventListener('submit', () => this.onSubmit());
      this.querySelector('[data-reset]')?.addEventListener('click', () => this.reset());
      window.addEventListener('pageshow', (event) => event.persisted && this.idle());

      if (!this.success.hidden) this.showSent();
    }

    syncPhone() {
      const choice = this.form.querySelector('input[name="contact[Preferred contact]"]:checked');
      if (this.phone) this.phone.required = Boolean(choice?.hasAttribute('data-needs-phone'));
    }

    onSubmit() {
      const data = new FormData(this.form);
      try {
        sessionStorage.setItem(
          STORE_KEY,
          JSON.stringify({
            name: (data.get('contact[name]') || '').toString().trim().split(' ')[0],
            method: (data.get('contact[Preferred contact]') || '').toString().toLowerCase(),
          })
        );
      } catch (e) {}

      const label = this.submitButton.querySelector('[data-submit-label]');
      this.idleLabel = this.idleLabel || label.textContent;
      label.innerHTML =
        '<svg class="sok-spinner" width="22" height="22" viewBox="0 0 18 18" aria-hidden="true"><circle cx="9" cy="9" r="7" fill="none" stroke="currentColor" stroke-opacity=".25" stroke-width="2"/><path d="M9 2a7 7 0 0 1 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      this.submitButton.setAttribute('aria-busy', 'true');
      // If a captcha challenge is dismissed the page never leaves, so give the button back.
      clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(() => this.idle(), 10000);
    }

    idle() {
      if (!this.idleLabel) return;
      this.submitButton.querySelector('[data-submit-label]').textContent = this.idleLabel;
      this.submitButton.removeAttribute('aria-busy');
    }

    showSent() {
      // Both this form and the consult form post to /contact; the anchor says which one was sent.
      if (location.hash && location.hash !== `#${this.form.id}`) {
        this.reset(false);
        return;
      }

      let sent = {};
      try {
        sent = JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
        sessionStorage.removeItem(STORE_KEY);
      } catch (e) {}

      const title = this.success.querySelector('[data-success-title]');
      const text = this.success.querySelector('[data-success-text]');
      title.textContent = this.dataset.thanks.replace('[name]', sent.name || title.dataset.fallback || 'there');
      if (sent.method) text.textContent = this.dataset.successCopy.replace('[method]', sent.method);

      this.scrollIntoView({ block: 'center' });
      this.success.focus({ preventScroll: true });
      history.replaceState(null, '', location.pathname);
    }

    reset(focus = true) {
      this.success.hidden = true;
      this.fields.hidden = false;
      if (focus) this.form.querySelector('input:not([type="hidden"]):not([type="radio"])')?.focus();
    }
  }

  customElements.define('sok-contact-form', SokContactForm);
}
